import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m12.729 1.2 3.346 6.629 6.44.638a.805.805 0 0 1 .5 1.374l-5.3 5.253 1.965 7.138a.813.813 0 0 1-1.151.935L12 19.934l-6.52 3.229a.813.813 0 0 1-1.151-.935l1.965-7.138L.99 9.837a.805.805 0 0 1 .5-1.374l6.44-.638L11.271 1.2a.819.819 0 0 1 1.458 0Z",
		fill: "#FAAD14",
		fillRule: "evenodd",
		stroke: "#FAAD14",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22m12.729%201.2%203.346%206.629%206.44.638a.805.805%200%200%201%20.5%201.374l-5.3%205.253%201.965%207.138a.813.813%200%200%201-1.151.935L12%2019.934l-6.52%203.229a.813.813%200%200%201-1.151-.935l1.965-7.138L.99%209.837a.805.805%200%200%201%20.5-1.374l6.44-.638L11.271%201.2a.819.819%200%200%201%201.458%200Z%22%20fill%3D%22%23FAAD14%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22%23FAAD14%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
